module.exports = __webpack_public_path__ + "img/book.85c261c8.png";